// ai-queue.service.ts
import { Injectable } from '@angular/core';

export interface QueueTask {
  id: string; // component id
  action: () => Promise<void>; // the async action (ex: onGenerate)
  resolve: () => void;
  reject: (err: any) => void;
}

@Injectable({
  providedIn: 'root'
})
export class AiFieldQueueService {
  private maxConcurrent = 1; // limit parallel generations
  private running = 0;
  private queue: QueueTask[] = [];

  // register a component task
  enqueue(id: string, action: () => Promise<void>): Promise<void> {
    return new Promise((resolve, reject) => {
      this.queue.push({ id, action, resolve, reject });
      this.process();
    });
  }

  private async process() {
    if (this.running >= this.maxConcurrent) return;
    const task = this.queue.shift();
    if (!task) return;

    this.running++;
    try {
      await task.action();
      task.resolve();
    } catch (err) {
      task.reject(err);
    } finally {
      this.running--;
      this.process(); // run next
    }
  }

  // cancel pending tasks for a component
  cancelById(id: string) {
    this.queue = this.queue.filter(t => t.id !== id);
  }

  // force trigger for a specific component (if you want external control)
  triggerFor(id: string) {
    const task = this.queue.find(t => t.id === id);
    if (task) {
      this.queue = this.queue.filter(t => t !== task);
      this.queue.unshift(task); // put at front
      this.process();
    }
  }
}
